import Api from '@/api'

export default {
  namespaced: true,

  actions: {
    async subscribeToPremium({ commit }, formData) {
      const { data } = await Api.post(`subscription`, formData)

      return data.data
    },

    async cancelSubscription() {
      const { data } = await Api.delete(`subscription`)

      return data
    }
  }
}
